import clsx from 'clsx';
import React, { Component } from 'react';
import { eventLevels } from 'react-big-calendar/lib/utils/eventLevels';
import GapAwareEventRowMixin from './gapAwareEventRowMixin';

function intRange(start, end) {
  const out = [];
  for (let i = start; i < end; i += 1) out.push(i);
  return out;
}

const isSegmentInSlot = (seg, slot) => seg.left <= slot && seg.right >= slot;

function eventsInSlot(segments, slot) {
  return segments
    .filter((seg) => isSegmentInSlot(seg, slot))
    .map((seg) => seg.event);
}

export default class GapAwareEventEndingRow extends Component {
  getHiddenEventsForSlot(segments, slot) {
    const allEventsInSlot = eventsInSlot(segments, slot);
    const rowSegments = eventLevels(segments).levels[0];
    const visibleEventsInSlot = rowSegments
      .filter((seg) => isSegmentInSlot(seg, slot))
      .map((seg) => seg.event);
    return allEventsInSlot.filter(
      (event) => !visibleEventsInSlot.some((visEvent) => visEvent === event)
    );
  }

  canRenderSlotEvent(slot, span) {
    const { segments } = this.props;
    return intRange(slot, slot + span).every((s) => eventsInSlot(segments, s).length === 1);
  }

  renderShowMore(segments, slot) {
    const { localizer, slotMetrics, components } = this.props;
    const events = slotMetrics.getEventsForSlot(slot);
    const remainingEvents = eventsInSlot(segments, slot);
    const count = remainingEvents.length;
    if (components?.showMore) {
      const ShowMore = components.showMore;
      const slotDate = slotMetrics.getDateForSlot(slot - 1);
      return count ? (
        <ShowMore
          localizer={localizer}
          slotDate={slotDate}
          slot={slot}
          count={count}
          events={events}
          remainingEvents={remainingEvents}
        />
      ) : (
        false
      );
    }
    return count ? (
      <button
        type="button"
        key={`sm_${slot}`}
        className={clsx('rbc-button-link', 'rbc-show-more')}
        onClick={(e) => this.showMore(slot, e)}
      >
        {localizer.messages.showMore(count, remainingEvents, events)}
      </button>
    ) : (
      false
    );
  }

  showMore(slot, e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onShowMore(slot, e.target);
  }

  render() {
    const { segments, slotMetrics } = this.props;
    const slots = slotMetrics.slots;
    const rowSegments = eventLevels(segments).levels[0];
    let current = 1;
    let lastEnd = 1;
    const row = [];
    while (current <= slots) {
      const key = `_lvl_${current}`;
      const seg =
        rowSegments.filter((s) => isSegmentInSlot(s, current))[0] || {};
      const { event, left, right, span } = seg;
      if (!event) {
        const hiddenEvents = this.getHiddenEventsForSlot(segments, current);
        if (hiddenEvents.length > 0) {
          const gapBefore = current - lastEnd;
          if (gapBefore) {
            row.push(
              GapAwareEventRowMixin.renderSpan(slots, gapBefore, `${key}_gap`)
            );
          }
          row.push(
            GapAwareEventRowMixin.renderSpan(
              slots,
              1,
              key,
              this.renderShowMore(segments, current)
            )
          );
          lastEnd = current + 1;
          current = current + 1;
          continue;
        }
        current += 1;
        continue;
      }
      const gap = Math.max(0, left - lastEnd);
      if (this.canRenderSlotEvent(left, span)) {
        const content = GapAwareEventRowMixin.renderEvent(this.props, event);
        if (gap) {
          row.push(GapAwareEventRowMixin.renderSpan(slots, gap, `${key}_gap`));
        }
        row.push(GapAwareEventRowMixin.renderSpan(slots, span, key, content));
        lastEnd = right + 1;
        current = right + 1;
      } else {
        if (gap) {
          row.push(GapAwareEventRowMixin.renderSpan(slots, gap, `${key}_gap`));
        }
        row.push(
          GapAwareEventRowMixin.renderSpan(
            slots,
            1,
            key,
            this.renderShowMore(segments, current)
          )
        );
        lastEnd = current + 1;
        current = current + 1;
      }
    }
    return <div className="rbc-row">{row}</div>;
  }
}

GapAwareEventEndingRow.defaultProps = { ...GapAwareEventRowMixin.defaultProps };
